import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Button, useTheme } from "@mui/material";

interface SubmitButtonProps {
  mode: "create" | "edit";
  isSubmitting: boolean;
  disabled?: boolean;
}

export const SubmitButton = ({
  mode,
  isSubmitting,
  disabled = false,
}: SubmitButtonProps) => {
  const { colors, customSpacing, radius, customFontWeight } = useTheme();
  const { t } = useResource();

  const getButtonText = () => {
    if (isSubmitting) {
      return t(Resources.Common.Blocked);
    }
    return mode === "create"
      ? t(Resources.Pages.CreateQuest.SubmitText)
      : t(Resources.Pages.EditQuest.SubmitText);
  };

  return (
    <Button
      type="submit"
      variant="contained"
      disabled={disabled || isSubmitting}
      sx={{
        width: 96,
        backgroundColor: colors.background.brandPrimary,
        color: colors.text.onbrand,
        borderRadius: radius.full,
        p: `${customSpacing.sm} ${customSpacing.lg}`,
        textTransform: "none",
        fontWeight: customFontWeight.bold,
        "&:hover": {
          backgroundColor: colors.background.brandSecondary,
        },
        "&:disabled": {
          opacity: 0.6,
        },
      }}
    >
      {getButtonText()}
    </Button>
  );
};
